import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import MentionsLegales from "./pages/MentionsLegales";
import PolitiqueConfidentialite from "./pages/PolitiqueConfidentialite";
import GuideRenovation from "./pages/GuideRenovation";
import GuideAides from "./pages/GuideAides";
import Partenaires from "./pages/Partenaires";
import CGV from "./pages/CGV";
import Boutique from "./pages/Boutique";
import Header from "./components/Header";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/mentions-legales" element={<><Header /><MentionsLegales /></>} />
          <Route path="/politique-confidentialite" element={<><Header /><PolitiqueConfidentialite /></>} />
          <Route path="/guide-renovation" element={<><Header /><GuideRenovation /></>} />
          <Route path="/guide-aides" element={<><Header /><GuideAides /></>} />
          <Route path="/partenaires" element={<Partenaires />} />
          <Route path="/cgv" element={<><Header /><CGV /></>} />
          <Route path="/boutique" element={<><Header /><Boutique /></>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
